import React, { useState } from "react";
import { sha256 } from "js-sha256";
import { Button, TextField, Grid, MenuItem } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import "../../../../css/Register.css";

function CreateCoach() {
  const [lNameErrorText, setlNameErrorText] = useState("");
  const [lNameHasError, setlNameHasError] = useState(false);
  const [fNameErrorText, setfNameErrorText] = useState("");
  const [fNameHasError, setfNameHasError] = useState(false);
  const [emailErrorText, setEmailErrorText] = useState("");
  const [emailHasError, setEmailHasError] = useState(false);
  const [email, setEmail] = useState("");
  const [lName, setLName] = useState("");
  const [fName, setFName] = useState("");
  const [coa_ville, setCoa_ville] = useState("");
  const [coa_villeError, setCoa_villeError] = useState("");

  // Permet de stocker la modification du champ lastname
  const onChangeLName = (e) => {
    setLName(e.target.value);
    setlNameHasError(false);
  };

  // Permet de stocker la modification du champ firstname
  const onChangeFName = (e) => {
    setFName(e.target.value);
    setfNameHasError(false);
  };

  // Permet de stocker la modification du champ email
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
    setEmailHasError(false);
  };

  // Permet de stocker la modification du champ ville
  const onChangeVille = async (e) => {
    setCoa_villeError("");
    setCoa_ville(e.target.value);
  };

  // Permet de valider que tous les champs sont bien remplis
  function validate() {
    let errors = false;
    if (lName.length === 0) {
      errors = true;
      setlNameHasError(true);
      setlNameErrorText("Le nom de famille doit être rempli !");
    }
    if (fName.length === 0) {
      errors = true;
      setfNameHasError(true);
      setfNameErrorText("Le prénom doit être rempli !");
    }
    if (
      !new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
        email.toString()
      )
    ) {
      errors = true;
      setEmailHasError(true);
      setEmailErrorText("Le format de l'email n'est pas correct !");
    }
    if (email.length === 0) {
      errors = true;
      setEmailHasError(true);
      setEmailErrorText("Email doit être rempli !");
    }
    return errors;
  }

  // Permet de sauvegarder la création d'un coach sur la base de donnée
  const registerHandler = async (e) => {
    e.preventDefault();
    const errors = validate();
    if (!errors) {
      e.preventDefault();
      let requestURL = window.$apiURL.toString() + "register/coach";
      let RegisterFormData = document.getElementById("registerForm");
      let formData = new FormData(RegisterFormData);
      formData.set("password", sha256("motdepasse123"));
      formData.set("password_confirmation", sha256("motdepasse123"));
      formData.set("coa_ville", coa_ville);
      formData.append("isAdmin", "0");
      formData.append("isValidated", "0");
      const requestOptions = {
        crossDomain: true,
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("cbs_perform_token"),
        },
        body: formData,
      };
      const responsePromise = await fetch(requestURL, requestOptions);
      const data = await responsePromise.json();
      if (!responsePromise.ok) {
        if (data.error.email !== null) {
          setEmailHasError(true);
          setEmailErrorText("Cette adresse email est déjà prise");
        }
      } else {
        localStorage.setItem("user_mail", data.success.email);
        window.location.replace("/MailNotificationPage");
      }
    }
  };

  // Affichage de la page
  return (
    <div>
      <Container component="main" maxWidth="xs" className="divRegister">
        <CssBaseline />
        <Typography
          component="h1"
          variant="h3"
          style={{ paddingBottom: "10%" }}
        >
          Nouveau coach
        </Typography>
        <br />
        <br />
        <form id="registerForm" autoComplete="on">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                autoComplete="family-name"
                name="coa_nom"
                helperText={lNameHasError ? lNameErrorText : ""}
                error={lNameHasError}
                onChange={(e) => onChangeLName(e)}
                required
                fullWidth
                id="lastName"
                label="Nom de Famille"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                onChange={(e) => onChangeFName(e)}
                autoComplete="first-name"
                name="coa_prenom"
                required
                helperText={fNameHasError ? fNameErrorText : ""}
                error={fNameHasError}
                fullWidth
                id="firstName"
                label="Prénom"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                onChange={(e) => onChangeEmail(e)}
                helperText={emailHasError ? emailErrorText : ""}
                error={emailHasError}
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                variant={"outlined"}
                onChange={(e) => onChangeVille(e)}
                name="coa_ville"
                value={coa_ville}
                error={coa_villeError !== ""}
                helperText={coa_villeError !== "" ? coa_villeError : ""}
                label="Ville"
              >
                <MenuItem value={"geneve"}>Genève</MenuItem>
                <MenuItem value={"lausanne"}>Lausanne</MenuItem>
              </TextField>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ paddingBottom: "10%", paddingTop: "10%" }}
            >
              <Button
                style={{ backgroundColor: "#857A73" }}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                onClick={(e) => registerHandler(e)}
              >
                {" "}
                Enregistrer le coach
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </div>
  );
}

export default CreateCoach;
